"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRUSTED_VERIFICATION_INCOMPLETE = exports.X_SECURITY_HEADER = exports.LIMIT_EXCEDEED_RESPONSE_ERROR = exports.NO_TRUSTED_ERROR = exports.OTP_LIMIT_CUSTOM_HTTP_STATUS = exports.BUSSINESS_VALIDATION_ERROR = void 0;
exports.BUSSINESS_VALIDATION_ERROR = 'BUSINESS_VALIDATION_FAILED';
exports.OTP_LIMIT_CUSTOM_HTTP_STATUS = 202;
exports.NO_TRUSTED_ERROR = '422 UNPROCESSABLE_ENTITY';
exports.LIMIT_EXCEDEED_RESPONSE_ERROR = 'limit-exceeded';
exports.X_SECURITY_HEADER = 'x-security';
exports.TRUSTED_VERIFICATION_INCOMPLETE = 'Validation from the trusted device is required';
//# sourceMappingURL=challenges.constants.js.map